module.exports = __webpack_public_path__ + "static/img/banner-sub-title.d346077.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner-sub-title.png
// module id = OL6x
// module chunks = 0